/**
 * @generated SignedSource<<7c0111da95ff1c75cdad79dbff1026cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarConnectionPlatform = "google" | "ics" | "outlook" | "%future added value";
export type OrganizationChannelMentionPermission = "admins" | "all" | "%future added value";
export type OrganizationCheckoutVersion = "stripe" | "stripe_acacia" | "%future added value";
export type OrganizationCurrency = "aed" | "afn" | "all" | "amd" | "ang" | "aoa" | "ars" | "aud" | "awg" | "azn" | "bam" | "bbd" | "bdt" | "bgn" | "bmd" | "bnd" | "bob" | "brl" | "bsd" | "bwp" | "byn" | "bzd" | "cad" | "chf" | "cny" | "cop" | "crc" | "cve" | "czk" | "dkk" | "dop" | "dzd" | "egp" | "etb" | "eur" | "fjd" | "fkp" | "gbp" | "gel" | "gip" | "gmd" | "hkd" | "hnl" | "htg" | "huf" | "idr" | "ils" | "inr" | "isk" | "jmd" | "kgs" | "lak" | "lbp" | "lkr" | "lrd" | "lsl" | "mad" | "mdl" | "mkd" | "mmk" | "mnt" | "mop" | "mur" | "mvr" | "mxn" | "myr" | "mzn" | "nad" | "ngn" | "nio" | "nok" | "npr" | "nzd" | "pab" | "pen" | "pgk" | "php" | "pkr" | "pln" | "qar" | "ron" | "rsd" | "rub" | "sar" | "sbd" | "scr" | "sek" | "sgd" | "shp" | "srd" | "std" | "szl" | "thb" | "tjs" | "top" | "try" | "ttd" | "twd" | "uah" | "usd" | "uyu" | "uzs" | "zar" | "zmw" | "%future added value";
export type OrganizationKind = "community" | "workspace" | "%future added value";
export type OrganizationRole = "admin" | "member" | "owner" | "%future added value";
export type OrganizationSubscriptionStatus = "active" | "paused" | "trial" | "trial_expired" | "%future added value";
export type OrganizationVisibility = "private" | "public" | "%future added value";
export type ProductOrderBy = "dates" | "misconfigured_stripe_objects" | "name" | "nav" | "published" | "%future added value";
export type SlackConnectionStatus = "active" | "auth_error" | "inactive" | "%future added value";
export type AppWithContextProvidersQuery$variables = {
  domain: string;
};
export type AppWithContextProvidersQuery$data = {
  readonly domain: {
    readonly id: string;
    readonly organization: {
      readonly authProvider: {
        readonly allowsJitProvisioning: boolean;
        readonly connectionId: string;
        readonly status: string;
      } | null;
      readonly billingContactEmail: string | null;
      readonly channelMentionPermission: OrganizationChannelMentionPermission;
      readonly checkoutVersion: OrganizationCheckoutVersion | null;
      readonly cover: string | null;
      readonly creationDatetime: string;
      readonly currency: OrganizationCurrency;
      readonly darkLogo: string | null;
      readonly description: string | null;
      readonly exploreProductTabSortBySetting: ProductOrderBy;
      readonly facebookPixelId: string | null;
      readonly faviconUrl: string | null;
      readonly googleAnalyticsId: string | null;
      readonly googleTagManagerId: string | null;
      readonly hasBackfilledStreamMessages: boolean | null;
      readonly id: string;
      readonly isChannelsEnabled: boolean;
      readonly isChatBotEnabled: boolean;
      readonly isDmEnabled: boolean;
      readonly isEventsEnabled: boolean;
      readonly isExploreProductTabHidden: boolean;
      readonly isProductsEnabled: boolean;
      readonly kind: OrganizationKind;
      readonly logo: string | null;
      readonly mobileAppConfig: {
        readonly id: string;
      } | null;
      readonly name: string;
      readonly primaryDomain: string;
      readonly showGlobalTabTitles: boolean;
      readonly slackConnectionStatus: SlackConnectionStatus | null;
      readonly slug: string;
      readonly stripeAccountId: string | null;
      readonly subscription: {
        readonly status: OrganizationSubscriptionStatus;
      } | null;
      readonly timezone: string;
      readonly viewerMembership: {
        readonly hasGroupLeadRole: boolean;
        readonly hasInstructorOrManagerRole: boolean;
        readonly hasSeenOnboarding: boolean;
        readonly id: string;
        readonly role: OrganizationRole;
        readonly shouldInitiateUserflow: boolean;
        readonly streamChatUserId: string | null;
        readonly streamChatUserToken: string | null;
      } | null;
      readonly visibility: OrganizationVisibility;
      readonly " $fragmentSpreads": FragmentRefs<"CommunityBadgeFragment" | "CustomThemeProviderActiveOrganizationFragment" | "LabelsContextActiveOrganizationFragment" | "useBrainSearchBotFragment" | "useChatBotFragment" | "useCommunityLandingPagesFragment" | "useCopilotBotFragment" | "useHasEntitlementActiveOrganizationFragment" | "usePermissionsFragment" | "useSubscriptionStandingActiveOrganizationFragment">;
    };
  } | null;
  readonly viewer: {
    readonly authProviderId: string | null;
    readonly avatar: string;
    readonly bio: string;
    readonly calendarConnection: {
      readonly id: string;
      readonly platform: CalendarConnectionPlatform;
    } | null;
    readonly canCreateTrialOrganization: boolean;
    readonly cover: string | null;
    readonly creationDatetime: string;
    readonly email: string;
    readonly firstName: string | null;
    readonly fullName: string;
    readonly hasAcceptedTerms: boolean;
    readonly id: string;
    readonly isTest: boolean;
    readonly isVerified: boolean;
    readonly lastActiveOrganizationMembership: {
      readonly organization: {
        readonly primaryDomain: string;
      };
    } | null;
    readonly lastName: string | null;
    readonly timezone: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment" | "ProfileAvatarWithDetailsFragment">;
  } | null;
};
export type AppWithContextProvidersQuery = {
  response: AppWithContextProvidersQuery$data;
  variables: AppWithContextProvidersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "domain"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "domain",
    "variableName": "domain"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "faviconUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stripeAccountId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDmEnabled",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isChannelsEnabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channelMentionPermission",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProductsEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExploreProductTabHidden",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEventsEnabled",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showGlobalTabTitles",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingContactEmail",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleAnalyticsId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookPixelId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleTagManagerId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exploreProductTabSortBySetting",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasBackfilledStreamMessages",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkoutVersion",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "darkLogo",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streamChatUserId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "OrganizationMembership",
  "kind": "LinkedField",
  "name": "viewerMembership",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSeenOnboarding",
      "storageKey": null
    },
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInstructorOrManagerRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGroupLeadRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streamChatUserToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shouldInitiateUserflow",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connectionId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowsJitProvisioning",
  "storageKey": null
},
v35 = [
  (v2/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "MobileAppConfig",
  "kind": "LinkedField",
  "name": "mobileAppConfig",
  "plural": false,
  "selections": (v35/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isChatBotEnabled",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackConnectionStatus",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryDomain",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerified",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAcceptedTerms",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarConnection",
  "kind": "LinkedField",
  "name": "calendarConnection",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "platform",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authProviderId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canCreateTrialOrganization",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTest",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v53 = [
  (v52/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v55 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v52/*: any*/),
  (v54/*: any*/)
],
v56 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v52/*: any*/),
  (v54/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppWithContextProvidersQuery",
    "selections": [
      {
        "alias": "domain",
        "args": (v1/*: any*/),
        "concreteType": "DomainMapping",
        "kind": "LinkedField",
        "name": "domainMapping",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationSubscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthProvider",
                "kind": "LinkedField",
                "name": "authProvider",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useHasEntitlementActiveOrganizationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CustomThemeProviderActiveOrganizationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "usePermissionsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LabelsContextActiveOrganizationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useSubscriptionStandingActiveOrganizationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CommunityBadgeFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useCommunityLandingPagesFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useChatBotFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useCopilotBotFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useBrainSearchBotFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/),
          (v9/*: any*/),
          (v24/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileAvatarWithDetailsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileAvatarFragment"
          },
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationMembership",
            "kind": "LinkedField",
            "name": "lastActiveOrganizationMembership",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppWithContextProvidersQuery",
    "selections": [
      {
        "alias": "domain",
        "args": (v1/*: any*/),
        "concreteType": "DomainMapping",
        "kind": "LinkedField",
        "name": "domainMapping",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationSubscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthProvider",
                "kind": "LinkedField",
                "name": "authProvider",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v32/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entitlements",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryContrastColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardBackgroundColor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "navBackgroundColor",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v53/*: any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nonNullProductId",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      (v52/*: any*/),
                      (v54/*: any*/)
                    ],
                    "type": "Product",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v55/*: any*/),
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "Comment",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "Feed",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "Post",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nullableProductIdString",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productId",
                        "storageKey": null
                      },
                      (v52/*: any*/),
                      (v54/*: any*/)
                    ],
                    "type": "ContentUsage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "ChatChannel",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v56/*: any*/),
                    "type": "Dashboard",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v55/*: any*/),
                    "type": "AssignmentSubmission",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v53/*: any*/),
                    "type": "PathwayGroup",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v53/*: any*/),
                    "type": "BrainSearch",
                    "abstractKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelNodeConnection",
                "kind": "LinkedField",
                "name": "labels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "singular",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "plural",
                            "storageKey": null
                          },
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subscriptionStanding",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emoji",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "kinds",
                    "value": [
                      "community_home",
                      "community_marketing"
                    ]
                  }
                ],
                "concreteType": "LandingPageNodeConnection",
                "kind": "LinkedField",
                "name": "landingPages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LandingPageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LandingPage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Dashboard",
                            "kind": "LinkedField",
                            "name": "dashboard",
                            "plural": false,
                            "selections": (v35/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "landingPages(kinds:[\"community_home\",\"community_marketing\"])"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Bot",
                "kind": "LinkedField",
                "name": "chatBot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personality",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "embeddingsIndexName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "embeddingsNamespace",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "temperature",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "confidence",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emojiUse",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v30/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Bot",
                "kind": "LinkedField",
                "name": "copilotBot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v32/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Bot",
                "kind": "LinkedField",
                "name": "brainSearchBot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableWebSearch",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableMedia",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableSources",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableSuggestedPrompts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableSuggestedContentPrompts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BotSuggestedPromptNodeConnection",
                    "kind": "LinkedField",
                    "name": "suggestedPrompts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BotSuggestedPromptNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BotSuggestedPrompt",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "prompt",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/),
          (v9/*: any*/),
          (v24/*: any*/),
          (v51/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationMembership",
            "kind": "LinkedField",
            "name": "lastActiveOrganizationMembership",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v39/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v49/*: any*/),
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25f9c38c57179b14d166f8f459792445",
    "id": null,
    "metadata": {},
    "name": "AppWithContextProvidersQuery",
    "operationKind": "query",
    "text": "query AppWithContextProvidersQuery(\n  $domain: String!\n) {\n  domain: domainMapping(domain: $domain) {\n    id\n    organization {\n      id\n      kind\n      name\n      slug\n      timezone\n      currency\n      description\n      cover\n      faviconUrl\n      stripeAccountId\n      isDmEnabled\n      isChannelsEnabled\n      channelMentionPermission\n      isProductsEnabled\n      isExploreProductTabHidden\n      isEventsEnabled\n      showGlobalTabTitles\n      billingContactEmail\n      visibility\n      googleAnalyticsId\n      facebookPixelId\n      googleTagManagerId\n      creationDatetime\n      exploreProductTabSortBySetting\n      hasBackfilledStreamMessages\n      checkoutVersion\n      logo\n      darkLogo\n      viewerMembership {\n        id\n        role\n        hasSeenOnboarding\n        streamChatUserId\n        hasInstructorOrManagerRole\n        hasGroupLeadRole\n        streamChatUserToken\n        shouldInitiateUserflow\n      }\n      subscription {\n        status\n        id\n      }\n      authProvider {\n        connectionId\n        allowsJitProvisioning\n        status\n        id\n      }\n      mobileAppConfig {\n        id\n      }\n      isChatBotEnabled\n      slackConnectionStatus\n      primaryDomain\n      ...useHasEntitlementActiveOrganizationFragment\n      ...CustomThemeProviderActiveOrganizationFragment\n      ...usePermissionsFragment\n      ...LabelsContextActiveOrganizationFragment\n      ...useSubscriptionStandingActiveOrganizationFragment\n      ...CommunityBadgeFragment\n      ...useCommunityLandingPagesFragment\n      ...useChatBotFragment\n      ...useCopilotBotFragment\n      ...useBrainSearchBotFragment\n    }\n  }\n  viewer {\n    id\n    timezone\n    avatar\n    email\n    firstName\n    lastName\n    fullName\n    bio\n    cover\n    creationDatetime\n    ...ProfileAvatarWithDetailsFragment\n    ...ProfileAvatarFragment\n    isVerified\n    hasAcceptedTerms\n    calendarConnection {\n      id\n      platform\n    }\n    lastActiveOrganizationMembership {\n      organization {\n        primaryDomain\n        id\n      }\n      id\n    }\n    authProviderId\n    canCreateTrialOrganization\n    isTest\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment CommunityBadgeFragment on Organization {\n  name\n  badge {\n    id\n    kind\n    icon\n    color\n    ...BadgeFragment\n  }\n}\n\nfragment CustomThemeProviderActiveOrganizationFragment on Organization {\n  theme {\n    primaryColor\n    primaryContrastColor\n    backgroundColor\n    cardBackgroundColor\n    navBackgroundColor\n    kind\n    id\n  }\n}\n\nfragment LabelsContextActiveOrganizationFragment on Organization {\n  labels {\n    edges {\n      node {\n        id\n        kind\n        singular\n        plural\n        description\n      }\n    }\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment useBrainSearchBotFragment on Organization {\n  brainSearchBot {\n    id\n    name\n    status\n    enableWebSearch\n    enableMedia\n    enableSources\n    enableSuggestedPrompts\n    enableSuggestedContentPrompts\n    suggestedPrompts {\n      edges {\n        node {\n          id\n          prompt\n        }\n      }\n    }\n  }\n}\n\nfragment useChatBotFragment on Organization {\n  chatBot {\n    id\n    name\n    status\n    personality\n    embeddingsIndexName\n    embeddingsNamespace\n    temperature\n    confidence\n    emojiUse\n    kind\n    streamChatUserId\n  }\n}\n\nfragment useCommunityLandingPagesFragment on Organization {\n  landingPages(kinds: [community_home, community_marketing]) {\n    edges {\n      node {\n        id\n        kind\n        mode\n        dashboard {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useCopilotBotFragment on Organization {\n  copilotBot {\n    id\n    name\n    status\n  }\n}\n\nfragment useHasEntitlementActiveOrganizationFragment on Organization {\n  entitlements\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n\nfragment useSubscriptionStandingActiveOrganizationFragment on Organization {\n  subscriptionStanding\n}\n"
  }
};
})();

(node as any).hash = "70a085a3389f0119490e8f0ac3bd3cad";

export default node;
